import React, { useEffect, useMemo, useState } from 'react';
import cookingVideo from "./video/Stewart.mp4";


import {
  Menu,
  X,
  Phone,
  Mail,
  MapPin,
  Clock,
  ChefHat,
  UtensilsCrossed,
  Star,
  Facebook,
  Instagram,
  Twitter,
  ShoppingCart,
  Search,
  Filter,
  Bike,
  Heart,
  ArrowUpCircle
} from 'lucide-react';

import './App.css';

// Images
import home100 from './images/bg13.jpg';
import home1 from './images/home1.jpg';
import home2 from './images/home2.jpg';
import home3 from './images/home3.jpg';
import home4 from './images/home4.jpg';
import home5 from './images/home5.jpg';
import home6 from './images/home6.jpg';
import home7 from './images/home7.jpg';
import home8 from './images/home8.jpg';
import home9 from './images/home9.jpg';
import home10 from './images/home10.jpg';
import home11 from './images/home11.jpg';
import home12 from './images/home12.jpg';

import home13 from './images/home13.jpg';
import home14 from './images/home14.jpg';
import home15 from './images/home15.jpg';
import home16 from './images/home16.jpg';
import home17 from './images/home17.jpg';
import home18 from './images/home18.jpg';
import home19 from './images/home19.jpg';
import home20 from './images/home20.jpg';
import home21 from './images/home21.jpg';
import home22 from './images/home22.jpg';
import home23 from './images/home23.jpg';
import home24 from './images/home24.jpg';
import home25 from './images/home25.jpg';
import home26 from './images/home26.jpg';
import home27 from './images/home27.jpg';
import home28 from './images/home28.jpg';
import home29 from './images/home29.jpg';
import home30 from './images/home30.jpg';
import home31 from './images/home31.jpg';
import home32 from './images/home32.jpg';
import home33 from './images/home33.jpg';
import home34 from './images/home34.jpg';
import home35 from './images/home35.jpg';
import home36 from './images/home36.jpg';
import home37 from './images/home37.jpg';
import home38 from './images/home38.jpg';
import home39 from './images/home39.jpg';
import home40 from './images/home40.jpg';

// ---------- Helpers ----------
const CATEGORIES = [
  'All',
  'Main Course',
  'Rice',
  'Breads',
  'Vegetarian',
  'Appetizers',
  'Beverages',
  'Grill',
  'Desserts'
];

const fmt = new Intl.NumberFormat('en-LK', {
  style: 'currency',
  currency: 'LKR',
  maximumFractionDigits: 2
});

const baseMenu = [
  { id: 1, name: 'Chicken Tikka Masala', price: 1699.0, desc: 'Tender chicken in creamy tomato sauce', category: 'Main Course', img: home1, isSpecial: true },
  { id: 2, name: 'Butter Chicken', price: 1599.0, desc: 'Rich and creamy chicken curry', category: 'Main Course', img: home2 },
  { id: 3, name: 'Lamb Rogan Josh', price: 1899.0, desc: 'Aromatic lamb curry with spices', category: 'Main Course', img: home3 },
  { id: 4, name: 'Vegetable Biryani', price: 1099.0, desc: 'Fragrant basmati rice with vegetables', category: 'Rice', img: home4, isSpecial: true },
  { id: 5, name: 'Garlic Naan', price: 499.0, desc: 'Fresh bread with garlic and butter', category: 'Breads', img: home5 },
  { id: 6, name: 'Paneer Tikka', price: 1199.0, desc: 'Grilled cottage cheese with spices', category: 'Vegetarian', img: home6 },
  { id: 7, name: 'Samosa (2 pcs)', price: 300.0, desc: 'Crispy pastry with spiced chicken filling', category: 'Appetizers', img: home7 },
  { id: 8, name: 'Mango Lassi', price: 699.0, desc: 'Refreshing yogurt drink with mango', category: 'Beverages', img: home8 },
  { id: 9, name: 'Mutton Biryani', price: 1799.0, desc: 'Aromatic basmati rice cooked with tender mutton and spices', category: 'Rice', img: home9, isSpecial: true },
  { id: 10, name: 'BBQ Platter', price: 2099.0, desc: 'Grilled BBQ platter with assorted meats and sides', category: 'Grill', img: home10, isSpecial: true },
  { id: 11, name: 'Chocolate Milkshake', price: 499.0, desc: 'Rich and creamy chocolate milkshake topped with whipped cream', category: 'Beverages', img: home11 },
  { id: 12, name: 'Mongolian Noodles', price: 1299.0, desc: 'Stir-fried noodles with vegetables and special Mongolian sauce', category: 'Main Course', img: home12 },

  { id: 13, name: 'Chicken Shawarma', price: 1499.0, desc: 'Juicy marinated chicken wrapped with veggies & garlic sauce', category: 'Grill', img: home13 },
  { id: 14, name: 'Chicken Kothu', price: 1299.0, desc: 'Sri Lankan kothu roti tossed with chicken & spices', category: 'Main Course', img: home14 },
  { id: 15, name: 'Strawberry Ice Cream', price: 399.0, desc: 'Creamy strawberry ice cream made with real fruit', category: 'Desserts', img: home15 },
  { id: 16, name: 'Strawberry Milkshake', price: 599.0, desc: 'Thick strawberry shake topped with whipped cream', category: 'Beverages', img: home16 },
  { id: 17, name: 'Butter Naan', price: 449.0, desc: 'Soft tandoor-baked naan glazed with butter', category: 'Breads', img: home17 },
  { id: 18, name: 'Cheese Pasta', price: 1399.0, desc: 'Pasta tossed in a creamy three-cheese sauce', category: 'Main Course', img: home18 },
  { id: 19, name: 'Chicken Roll', price: 499.0, desc: 'Crispy roll stuffed with spiced chicken & onions', category: 'Appetizers', img: home19 },
  { id: 20, name: 'Fish BBQ', price: 1999.0, desc: 'Char-grilled fish with house marinade & lemon', category: 'Grill', img: home20 },
  { id: 21, name: 'French Fries', price: 399.0, desc: 'Golden fries—crispy outside, fluffy inside', category: 'Appetizers', img: home21 },
  { id: 22, name: 'Peanut Butter Ice Cream Sandwich Cake', price: 1299.0, desc: 'Ice cream layered dessert with peanut butter flavor', category: 'Desserts', img: home22 },
  { id: 23, name: 'Chicken Mayonnaise Sandwich', price: 899.0, desc: 'Creamy chicken mayo stuffed sandwich', category: 'Appetizers', img: home23 },
  { id: 24, name: 'Chicken Submarine', price: 1499.0, desc: 'Large submarine sandwich stuffed with chicken & veggies', category: 'Main Course', img: home24, isSpecial: true },
  { id: 25, name: 'Waffles with Ice Cream', price: 1199.0, desc: 'Hot waffles topped with cold ice cream', category: 'Desserts', img: home25 },
  { id: 26, name: 'Diamond Drizzle Cake Velvet', price: 1499.0, desc: 'Soft velvet cake drizzled with diamond-glaze frosting', category: 'Desserts', img: home26 },
  { id: 27, name: 'Strawberry Rosewater Pudding', price: 999.0, desc: 'Smooth strawberry pudding infused with delicate rosewater aroma', category: 'Desserts', img: home27 },
  { id: 28, name: 'Blue Lagoon Mocktail', price: 799.0, desc: 'Refreshing blue-lagoon mocktail with lemon & fizzy twist', category: 'Beverages', img: home28 },
  { id: 29, name: 'Fireberry Mojito', price: 899.0, desc: 'Spicy berry fusion mojito with mint & lime', category: 'Beverages', img: home29 },
  { id: 30, name: 'Dragonfire Crispy Chicken', price: 1699.0, desc: 'Crispy chicken tossed in fiery dragon sauce', category: 'Main Course', img: home30, isSpecial: true },
  { id: 31, name: 'Lemon Herb Grilled Prawns', price: 1999.0, desc: 'Juicy prawns grilled with lemon, garlic & herb seasoning', category: 'Grill', img: home31, isSpecial: true },
  { id: 32, name: 'Cheesy Lasagna', price: 1499.0, desc: 'Classic layered lasagna filled with rich cheese & meat sauce', category: 'Main Course', img: home32 },
  { id: 33, name: 'Rose Milk Falooda', price: 899.0, desc: 'Refreshing falooda with rose milk, jelly & ice cream', category: 'Beverages', img: home33 },
  { id: 34, name: 'Nutella Lava Cake', price: 1199.0, desc: 'Warm chocolate cake with molten Nutella center', category: 'Desserts', img: home34, isSpecial: true },
  { id: 35, name: 'Chicken Popcorn', price: 799.0, desc: 'Crispy bite-sized chicken pieces with seasoning', category: 'Appetizers', img: home35 },
  { id: 36, name: 'Dragon Noodles (Spicy)', price: 1299.0, desc: 'Fiery spicy noodles tossed with veggies & special dragon sauce', category: 'Main Course', img: home36 },
  { id: 37, name: 'Beef Devilled Fry', price: 1499.0, desc: 'Sri Lankan style spicy devilled beef with onions & peppers', category: 'Main Course', img: home37 },
  { id: 38, name: 'Oreo Mousse Cup', price: 699.0, desc: 'Creamy layered mousse topped with crushed Oreo', category: 'Desserts', img: home38 },
  { id: 39, name: 'Milka Milkshake', price: 999.0, desc: 'Thick chocolate milkshake blended with Milka chocolate', category: 'Beverages', img: home39 },
  { id: 40, name: 'Chicken Cheese Balls', price: 899.0, desc: 'Crispy fried balls stuffed with chicken & melted cheese', category: 'Appetizers', img: home40 }
];

// ---------- Nav links ----------
const NAV_LINKS = [
  { id: 'home', label: 'Home', href: '#home' },
  { id: 'about', label: 'About', href: '#about' },
  { id: 'menu', label: 'Menu', href: '#menu' },
  { id: 'delivery', label: 'Delivery', href: '#delivery' },
  { id: 'contact', label: 'Contact', href: '#contact' },
  { id: 'order-online', label: 'Order Online', href: '#menu' }
];

function useScrollSpy(ids = []) {
  const [active, setActive] = useState(ids[0]);
  useEffect(() => {
    const handler = () => {
      let current = ids[0];
      ids.forEach((id) => {
        const el = document.getElementById(id);
        if (el) {
          const rect = el.getBoundingClientRect();
          if (rect.top <= 120 && rect.bottom >= 120) current = id;
        }
      });
      setActive(current);
    };
    handler();
    window.addEventListener('scroll', handler, { passive: true });
    return () => window.removeEventListener('scroll', handler);
  }, [ids]);
  return active;
}

function isOpenNow() {
  const now = new Date();
  const hr = now.getHours();
  return hr >= 11 && hr < 22; // Daily 11:00–22:00
}

export default function App() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [query, setQuery] = useState('');
  const [category, setCategory] = useState('All');
  const [sort, setSort] = useState('featured');
  const [cart, setCart] = useState([]); // [{id, qty}]
  const [showPanel, setShowPanel] = useState(false);
  const [toast, setToast] = useState(null);
  const [orderType, setOrderType] = useState('dine-in'); // dine-in / delivery
  const [favoriteIds, setFavoriteIds] = useState([]); // favourite dishes
  const [showFavOnly, setShowFavOnly] = useState(false);
  const [showScrollTop, setShowScrollTop] = useState(false);

  const activeSection = useScrollSpy(['home', 'about', 'menu', 'delivery', 'contact']);

  useEffect(() => {
    const handleScroll = () => {
      const y = window.scrollY;
      setScrolled(y > 50);
      setShowScrollTop(y > 300);
    };
    handleScroll();
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const items = useMemo(() => baseMenu, []);
  const specials = useMemo(
    () => items.filter((i) => i.isSpecial).slice(0, 4),
    [items]
  );

  const filtered = useMemo(() => {
    let list = items;

    if (category !== 'All') {
      list = list.filter((i) => i.category === category);
    }

    if (showFavOnly && favoriteIds.length) {
      list = list.filter((i) => favoriteIds.includes(i.id));
    }

    if (query.trim()) {
      const q = query.toLowerCase();
      list = list.filter(
        (i) =>
          i.name.toLowerCase().includes(q) ||
          i.desc.toLowerCase().includes(q)
      );
    }

    const sorted = [...list];
    if (sort === 'price-asc') sorted.sort((a, b) => a.price - b.price);
    if (sort === 'price-desc') sorted.sort((a, b) => b.price - a.price);
    if (sort === 'alpha') sorted.sort((a, b) => a.name.localeCompare(b.name));

    return sorted;
  }, [items, category, query, sort, showFavOnly, favoriteIds]);

  const totalCount = cart.reduce((s, c) => s + c.qty, 0);
  const totalCost = cart.reduce((s, c) => {
    const it = items.find((i) => i.id === c.id);
    return s + (it ? it.price * c.qty : 0);
  }, 0);

  const showToast = (text) => {
    setToast(text);
    setTimeout(() => setToast(null), 1600);
  };

  const toggleFavorite = (id) => {
    setFavoriteIds((prev) =>
      prev.includes(id) ? prev.filter((pid) => pid !== id) : [...prev, id]
    );
  };

  const addToCart = (id) => {
    setCart((prev) => {
      const found = prev.find((p) => p.id === id);
      const next = found
        ? prev.map((p) => (p.id === id ? { ...p, qty: p.qty + 1 } : p))
        : [...prev, { id, qty: 1 }];
      return next;
    });
    showToast('Added to order');
  };

  const decQty = (id) =>
    setCart((prev) =>
      prev.flatMap((p) =>
        p.id === id ? (p.qty > 1 ? [{ ...p, qty: p.qty - 1 }] : []) : [p]
      )
    );

  const incQty = (id) =>
    setCart((prev) => prev.map((p) => (p.id === id ? { ...p, qty: p.qty + 1 } : p)));

  const removeItem = (id) =>
    setCart((prev) => prev.filter((p) => p.id !== id));

  // Reservation form state
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    date: '',
    time: '',
    guests: '',
    message: ''
  });
  const todayStr = new Date().toISOString().split('T')[0];

  const handleSubmit = (e) => {
    e.preventDefault();
    const required = ['name', 'email', 'phone', 'date', 'time', 'guests'];
    const missing = required.filter((k) => !formData[k]);
    if (missing.length) {
      showToast('Please fill in all required fields');
      return;
    }
    showToast('Reservation request sent!');
    setFormData({
      name: '',
      email: '',
      phone: '',
      date: '',
      time: '',
      guests: '',
      message: ''
    });
  };

  const handleInputChange = (e) =>
    setFormData({ ...formData, [e.target.name]: e.target.value });

  const closeMobileMenu = () => setIsMenuOpen(false);

  return (
    <div className="app">
      {/* Navbar */}
      <nav className={`navbar ${scrolled ? 'scrolled' : ''}`} aria-label="Primary">
        <div className="container nav-container">
          <div
            className="logo"
            onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
            aria-label="Foodzillaaaaa home"
          >
            <ChefHat size={32} />
            <span>Foodzillaaaaa</span>
          </div>

          <div className={`nav-links ${isMenuOpen ? 'active' : ''}`}>
            {NAV_LINKS.map((link) => {
              const isActive =
                link.id === 'order-online'
                  ? activeSection === 'menu'
                  : activeSection === link.id;

              return (
                <a
                  key={link.id}
                  href={link.href}
                  onClick={closeMobileMenu}
                  className={isActive ? 'active' : ''}
                >
                  {link.label}
                </a>
              );
            })}
          </div>

          <button
            className="menu-toggle"
            onClick={() => setIsMenuOpen((s) => !s)}
            aria-label="Toggle menu"
          >
            {isMenuOpen ? <X size={28} /> : <Menu size={28} />}
          </button>
        </div>
      </nav>

      {/* Hero (animation removed – only text now) */}
      <section
        id="home"
        className="hero"
        style={{
          backgroundImage: `url(${home100})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat'
        }}
      >
        <div className="hero-overlay"></div>
        <div className="hero-content">
          <div className="hero-text">
            <p className="hero-subtitle">Delightful Experience</p>
            <h1 className="hero-title">
              Welcome to
              <br />
              <span className="highlight">Foodzillaaaaa</span>
            </h1>
            <p className="hero-description">
              Come with family &amp; feel the joy of mouthwatering food
            </p>
            <div className="hero-buttons">
              <a href="#menu" className="btn btn-primary">
                View Menu
              </a>
              <a href="#contact" className="btn btn-secondary">
                Reserve Table
              </a>
            </div>
          </div>
        </div>
        <div className="hero-bg-pattern"></div>
      </section>

      {/* Specials */}
      <section className="specials" aria-labelledby="specials-title">
        <div className="container">
          <div className="section-header">
            <h2 id="specials-title" className="section-title">
              Today&apos;s Specials
            </h2>
            <div className="title-underline"></div>
            <p className="section-subtitle">
              Hand-picked favourites recommended by our chef
            </p>
          </div>
          <div className="specials-grid">
            {specials.map((item) => (
              <article key={item.id} className="special-card">
                <div className="special-img-wrap">
                  <img src={item.img} alt={item.name} loading="lazy" />
                  <span className="special-badge">Chef&apos;s pick</span>
                </div>
                <div className="special-body">
                  <div className="special-top">
                    <h3>{item.name}</h3>
                    <span className="price">{fmt.format(item.price)}</span>
                  </div>
                  <p className="special-desc">{item.desc}</p>
                  <button
                    type="button"
                    className="btn btn-primary special-btn"
                    onClick={() => addToCart(item.id)}
                  >
                    Add to Order
                  </button>
                </div>
              </article>
            ))}
          </div>
        </div>
      </section>
{/* About */}
<section id="about" className="about" aria-labelledby="about-title">
  <div className="container">
    <div className="section-header">
      <h2 id="about-title" className="section-title">Our Story</h2>
      <div className="title-underline"></div>
    </div>

    <div className="about-content">

      {/* LEFT — Video */}
      <div className="about-video">
        <video src={cookingVideo} autoPlay loop muted playsInline />
      </div>

      {/* RIGHT — Text */}
      <div className="about-text">
        <h3>Authentic Indian Cuisine</h3>
        <p>
          At Foodzillaaaaa, we bring you the soul of India through its rich flavors, vibrant spices, and timeless culinary traditions.
          Our master chefs craft every dish with heart and heritage, using age-old recipes that have been cherished and perfected over generations.
          Step into our warm and welcoming space, where every plate celebrates India’s diverse culture, and every bite feels like home.
        </p>
        <p>
          Experience the true essence of Indian hospitality — comforting, flavorful, and unforgettable.
        </p>

        <div className="about-features">
          {[
            {
              icon: <ChefHat size={40} />,
              title: 'Expert Chefs',
              desc: 'Authentic recipes from master chefs'
            },
            {
              icon: <UtensilsCrossed size={40} />,
              title: 'Fresh Ingredients',
              desc: 'Quality ingredients sourced daily'
            },
            {
              icon: <Star size={40} />,
              title: 'Premium Quality',
              desc: 'Award-winning dining experience'
            }
          ].map((item, i) => (
            <div key={i} className="feature-card">
              <div className="feature-icon">{item.icon}</div>
              <h4>{item.title}</h4>
              <p>{item.desc}</p>
            </div>
          ))}
        </div>
      </div>

    </div>
  </div>
</section>


      {/* Menu */}
      <section id="menu" className="menu-section" aria-labelledby="menu-title">
        <div className="container">
          <div className="section-header">
            <h2 id="menu-title" className="section-title">
              Our Menu
            </h2>
            <div className="title-underline"></div>
            <p className="section-subtitle">Discover our delicious offerings</p>
          </div>

          {/* Controls */}
          <div className="menu-controls" role="search">
            <div className="searchbar" aria-label="Search dishes">
              <Search size={18} />
              <input
                type="search"
                placeholder="Search dishes, e.g. biryani, chicken..."
                value={query}
                onChange={(e) => setQuery(e.target.value)}
                aria-label="Search menu"
              />
            </div>
            <div className="control-row">
              <select
                className="sort-select"
                value={sort}
                onChange={(e) => setSort(e.target.value)}
                aria-label="Sort menu"
              >
                <option value="featured">Featured</option>
                <option value="price-asc">Price: Low to High</option>
                <option value="price-desc">Price: High to Low</option>
                <option value="alpha">A → Z</option>
              </select>
              <button
                type="button"
                className={`fav-toggle ${showFavOnly ? 'active' : ''}`}
                onClick={() => setShowFavOnly((prev) => !prev)}
                aria-pressed={showFavOnly}
              >
                <Heart size={16} />
                {showFavOnly ? 'Favourites only' : 'Favourites'}
              </button>
            </div>
          </div>

          <div className="chips" aria-label="Filter by category">
            {CATEGORIES.map((c) => (
              <button
                key={c}
                className={`chip ${category === c ? 'active' : ''}`}
                onClick={() => setCategory(c)}
                aria-pressed={category === c}
              >
                <Filter size={16} style={{ opacity: 0.8 }} /> {c}
              </button>
            ))}
          </div>

          {/* Grid */}
          <div className="menu-grid" style={{ marginTop: '1.2rem' }}>
            {filtered.map((item) => {
              const isFav = favoriteIds.includes(item.id);
              return (
                <article key={item.id} className="menu-card">
                  <img src={item.img} alt={item.name} className="menu-img" loading="lazy" />
                  <div className="menu-card-header">
                    <h3>{item.name}</h3>
                    <div className="menu-card-meta">
                      <button
                        type="button"
                        className={`favorite-btn ${isFav ? 'active' : ''}`}
                        onClick={() => toggleFavorite(item.id)}
                        aria-label={isFav ? 'Remove from favourites' : 'Add to favourites'}
                      >
                        <Heart size={16} />
                      </button>
                      <span className="price">{fmt.format(item.price)}</span>
                    </div>
                  </div>
                  <span className="category">{item.category}</span>
                  <div className="rating" aria-label="Rating 4.6 out of 5">
                    <Star size={18} /> 4.6 Popular
                  </div>
                  <p className="menu-desc">{item.desc}</p>
                  <button className="add-btn" onClick={() => addToCart(item.id)}>
                    Add to Order
                  </button>
                </article>
              );
            })}
          </div>
        </div>
      </section>

      {/* Delivery Section */}
      <section id="delivery" className="delivery-section" aria-labelledby="delivery-title">
        <div className="container">
          <div className="section-header">
            <h2 id="delivery-title" className="section-title">
              Delivery &amp; Takeaway
            </h2>
            <div className="title-underline"></div>
            <p className="section-subtitle">
              Hot &amp; fresh Foodzillaaaaa favourites delivered to your doorstep
            </p>
          </div>

          <div className="delivery-grid">
            <div className="delivery-card">
              <div className="delivery-icon">
                <Bike size={40} />
              </div>
              <h3>Order for Delivery</h3>
              <p>
                Add your favourite dishes to the cart and choose <strong>"Delivery"</strong> at checkout.
                Our team will call you to confirm your address &amp; delivery time.
              </p>
              <ul className="delivery-list">
                <li>Delivery within 5km radius from the restaurant</li>
                <li>Average delivery time: 30–45 minutes</li>
                <li>Cash or card on delivery available</li>
              </ul>
              <div className="delivery-actions">
                <a href="tel:+94761234567" className="btn btn-primary">
                  Call to Order
                </a>
                <a href="#menu" className="btn btn-secondary">
                  Add Items from Menu
                </a>
              </div>
            </div>

            <div className="delivery-map-card">
              <h4>We are here</h4>
              <p>colombo,21 Galle Face Center Rd,Colombo 00100, Sri Lanka</p>
              <div className="map-wrapper">
                <iframe
                  title="Foodzillaaaaa Location Map"
                  src="https://www.google.com/maps?q=123%20Whitby%20Street%20Auckland%20Sri%20Lanka&output=embed"
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                ></iframe>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Contact */}
      <section id="contact" className="contact" aria-labelledby="contact-title">
        <div className="container">
          <div className="section-header">
            <h2 id="contact-title" className="section-title">
              Visit Us
            </h2>
            <div className="title-underline"></div>
            <p className="section-subtitle" role="status">
              {isOpenNow() ? 'Open now · Closes 10:00 PM' : 'Closed now · Opens 11:00 AM'}
            </p>
          </div>

          <div className="contact-grid">
            <div className="contact-info">
              <div className="info-card">
                <MapPin size={24} />
                <div>
                  <h4>Address</h4>
                  <p>
                    colombo,21 Galle Face Center Rd,Colombo 00100
                    <br />
                    Sri Lanka
                  </p>
                </div>
              </div>
              <a className="info-card" href="tel:+94761234567" aria-label="Call us">
                <Phone size={24} />
                <div>
                  <h4>Phone</h4>
                  <p>+94 76 123 4567</p>
                </div>
              </a>
              <a
                className="info-card"
                href="mailto:info@Foodzillaaaaarestaurant@gmail.com"
                aria-label="Email us"
              >
                <Mail size={24} />
                <div>
                  <h4>Email</h4>
                  <p>info@Foodzillaaaaa@gmail.com</p>
                </div>
              </a>
              <div className="info-card">
                <Clock size={24} />
                <div>
                  <h4>Hours</h4>
                  <p>Mon–Sun: 11:00 AM – 10:00 PM</p>
                </div>
              </div>
            </div>

            <div className="contact-form">
              <h3>Make a Reservation</h3>
              <form className="reservation-form" onSubmit={handleSubmit}>
                <input
                  type="text"
                  name="name"
                  placeholder="Your Name"
                  value={formData.name}
                  onChange={handleInputChange}
                  required
                />
                <input
                  type="email"
                  name="email"
                  placeholder="Your Email"
                  value={formData.email}
                  onChange={handleInputChange}
                  required
                />
                <input
                  type="tel"
                  name="phone"
                  placeholder="Phone Number"
                  value={formData.phone}
                  onChange={handleInputChange}
                  required
                />
                <input
                  type="date"
                  name="date"
                  value={formData.date}
                  onChange={handleInputChange}
                  min={todayStr}
                  required
                />
                <input
                  type="time"
                  name="time"
                  value={formData.time}
                  onChange={handleInputChange}
                  required
                />
                <select
                  name="guests"
                  value={formData.guests}
                  onChange={handleInputChange}
                  required
                >
                  <option value="">Number of Guests</option>
                  <option value="1-2">1–2 Guests</option>
                  <option value="3-4">3–4 Guests</option>
                  <option value="5+">5-10 Guests</option>
                  <option value="10+">10+ Guests</option>
                </select>
                <textarea
                  name="message"
                  placeholder="Special Requests"
                  rows={3}
                  value={formData.message}
                  onChange={handleInputChange}
                ></textarea>
                <button type="submit" className="btn btn-primary">
                  Book Now
                </button>
              </form>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="footer">
        <div className="container">
          <div className="footer-content">
            <div className="footer-section">
              <h3>Foodzillaaaaa</h3>
              <p>Experience authentic Indian cuisine in the heart of Foodzillaaaaa</p>
              <div className="social-links">
                <a href="#" aria-label="Facebook" title="Facebook">
                  <Facebook size={20} />
                </a>
                <a href="#" aria-label="Instagram" title="Instagram">
                  <Instagram size={20} />
                </a>
                <a href="#" aria-label="Twitter" title="Twitter">
                  <Twitter size={20} />
                </a>
              </div>
            </div>
            <div className="footer-section">
              <h4>Quick Links</h4>
              <a href="#home">Home</a>
              <a href="#about">About</a>
              <a href="#menu">Menu</a>
              <a href="#delivery">Delivery</a>
              <a href="#contact">Contact</a>
            </div>
            <div className="footer-section">
              <h4>Contact</h4>
              <p>colombo,</p>
              <p>21 Galle Face Center Rd,</p>
              <p>Colombo 00100</p>
              <p>+94 76 123 4567</p>
              <p>info@Foodzillaaaaarestaurant@gmail.com</p>
            </div>
          </div>
          <div className="footer-bottom">
            <p>&copy; {new Date().getFullYear()} Foodzillaaaaa Restaurant. All rights reserved.</p>
          </div>
        </div>
      </footer>

      {/* Cart Floating Button */}
      <button
        className="cart-fab"
        onClick={() => setShowPanel((s) => !s)}
        aria-label="Open cart"
      >
        <ShoppingCart size={18} />
        <span>Order</span>
        <span className="count">{totalCount}</span>
      </button>

      {/* Scroll to top button */}
      {showScrollTop && (
        <button
          className="scroll-top-btn"
          onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
          aria-label="Scroll to top"
        >
          <ArrowUpCircle size={22} />
        </button>
      )}

      {/* Cart Panel */}
      {showPanel && (
        <aside className="cart-panel" role="dialog" aria-label="Order summary">
          <div className="cart-header">
            <div className="cart-title">
              <span className="cart-title-main">Your Order</span>
              <span className="cart-title-count">
                {totalCount || 0} item{totalCount === 1 ? '' : 's'}
              </span>
            </div>
            <button
              onClick={() => setShowPanel(false)}
              aria-label="Close cart"
              className="cart-close-btn"
            >
              <X size={16} />
            </button>
          </div>
          <div className="cart-body">
            {cart.length === 0 && <p style={{ padding: '1rem' }}>Your cart is empty.</p>}
            {cart.map((c) => {
              const it = items.find((i) => i.id === c.id);
              if (!it) return null;
              return (
                <div key={c.id} className="cart-item">
                  <img src={it.img} alt="" />
                  <div>
                    <h5>{it.name}</h5>
                    <div className="qty" aria-label={`Quantity ${c.qty}`}>
                      <button
                        className="qty-btn"
                        onClick={() => decQty(c.id)}
                        aria-label="Decrease"
                      >
                        –
                      </button>
                      <span className="qty-value">{c.qty}</span>
                      <button
                        className="qty-btn"
                        onClick={() => incQty(c.id)}
                        aria-label="Increase"
                      >
                        +
                      </button>
                    </div>
                  </div>
                  <div className="cart-item-right">
                    <div className="cart-line-total">
                      {fmt.format(it.price * c.qty)}
                    </div>
                    <button
                      onClick={() => removeItem(c.id)}
                      className="remove-btn"
                    >
                      Remove
                    </button>
                  </div>
                </div>
              );
            })}
          </div>
          <div className="cart-footer">
            <div className="order-type">
              <span className="order-type-label">Order Type</span>
              <div className="order-type-options">
                <button
                  type="button"
                  className={`order-type-chip ${orderType === 'dine-in' ? 'active' : ''}`}
                  onClick={() => setOrderType('dine-in')}
                >
                  Dine-in / Pickup
                </button>
                <button
                  type="button"
                  className={`order-type-chip ${orderType === 'delivery' ? 'active' : ''}`}
                  onClick={() => setOrderType('delivery')}
                >
                  Delivery
                </button>
              </div>
            </div>

            <p className="order-type-note">
              {orderType === 'delivery'
                ? 'We will call you to confirm your delivery address and time.'
                : 'We will confirm your table reservation when you contact us.'}
            </p>

            <div
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                fontWeight: 800
              }}
            >
              <span>Total</span>
              <span>{fmt.format(totalCost)}</span>
            </div>
            <a
              href={orderType === 'delivery' ? '#delivery' : '#contact'}
              className="checkout-btn"
              onClick={() => setShowPanel(false)}
            >
              {orderType === 'delivery' ? 'Proceed with Delivery' : 'Checkout / Reserve'}
            </a>
          </div>
        </aside>
      )}

      {/* Snackbar */}
      <div className={`snackbar ${toast ? 'show' : ''}`} role="status" aria-live="polite">
        {toast && (
          <>
            <ShoppingCart size={16} /> {toast}
          </>
        )}
      </div>
    </div>
  );
}
